import { GetServerSideProps, NextPage } from 'next';
import React from 'react';

import { pagesConfigStore } from '~/atomic/atom/links/pagesConfigStore';
import { LayoutType } from '~/atomic/layout/DefaultLayout';
import { PageTemplate } from '~/atomic/organism/PageTemplate/PageTemplate';
import { ImAuthor } from '~/atomic/page/im-author/ImAuthor';
import { checkAuthToken } from '~/feature/authorization/checkAuthToken';
import { SiteTemplate } from '~/feature/template/SiteTemplate';
import { createStore, RootState } from '~/store';

const ImAuthorPage: NextPage & LayoutType = () => {
  const title = 'Возможности Bookriver для авторов';
  const description = 'Площадка и инструменты для эффективного выстраивания '
    + 'авторами продаж своих произведений и формирования своей читательской аудитории';

  return (
    <PageTemplate
      isPublic={pagesConfigStore.imAuthor.isPublic}
      seo={{
        title,
        description,
        canonical: pagesConfigStore.imAuthor.url,
      }}
      content={(
        <ImAuthor />
      )}
    />
  );
};

ImAuthorPage.getLayout = (page) => (
  <SiteTemplate>
    { page }
  </SiteTemplate>
);

export const getServerSideProps: GetServerSideProps<
{ state: RootState; },
{ genres: string[]; }
> = async (context) => {
  const { dispatch, store } = await createStore();
  const isLoggedIn = await checkAuthToken(context, dispatch);

  const state = store.getState();
  return { props: { state } };
};

export default ImAuthorPage;
